// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__UnNao","noInteraction":"EventWrapper_noInteraction__3LTiQ","pointerPassthrough":"EventWrapper_pointerPassthrough__H1Uaa"};